<template>
<div style="width:100%;">
  <w-rsc-tree ref="rscTree" class="mr-r20" style="display:inline-block; float: left; width:300px;" :managetype-list="managetypeList" @select-node="selectNode"></w-rsc-tree>
  <w-event-template-table style="display:inline-block; float: right; width:calc(100% - 320px);" :managetype-list="managetypeList" :selected-node="selectedNode"></w-event-template-table>
</div>
</template>

<script>
import WRscTree from './components/RscTree';
import WEventTemplateTable from './components/EventTemplateTable';

export default {
  name: 'WCommonEvent',
  components: {
    WRscTree,
    WEventTemplateTable,
  },
  computed: {
    managetypeList() {
      return this.$store.getters.activeManagetypesToShowForRsc;
    },
  },
  data() {
    return {
      selectedNode: null,
    };
  },
  methods: {
    selectNode(selectedNode) {
      this.selectedNode = selectedNode;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/EventSettings/CommonEvent.vue